import consumerApi from "@/api/services/consumer-api";

export type ArticleSponsorId = number;
export type ArticleSponsorType = "category" | "brand";

export type GetSponsoredArticles = {
  id: ArticleSponsorId;
  sponsorType: ArticleSponsorType;
};

export type SponsoredArticle = {
  id: number;
  author: string;
  sponsorName: string;
  excerpt: string;
  date: string;
  image: string;
  link: string;
  slug: string;
  title: string;
  tags: string[];
};

export type SponsoredArticlesResponse = {
  data: SponsoredArticle[];
  metadata: {
    totalCount: number;
  };
};

const getSponsoredArticles = async ({
  id,
  sponsorType,
}: GetSponsoredArticles) => {
  const sponsoredArticlesResponse =
    await consumerApi.get<SponsoredArticlesResponse>(
      `/api/articles/v1/sponsored/${sponsorType}?ids[]=${id}`,
      {
        headers: {
          "X-Country-Code": "US",
        },
      },
    );
  return sponsoredArticlesResponse?.data?.data;
};

export default getSponsoredArticles;
